import { createAsyncThunk } from "@reduxjs/toolkit";
import { type EducationTopic } from "../../../domain/entities/education-topic";
import { type MarkTopicParams } from "../../../domain/repos/education-repo";
import { type EducationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const markTopic = createAsyncThunk<
  EducationTopic,
  MarkTopicParams,
  { dispatch: EducationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.MARK_TOPIC, async (params, { extra }) => {
  return await extra.educationRepo.markTopic(params);
});
